import { render } from "./TransformationFactoryPopup.vue?vue&type=template&id=4e22289c&scoped=true"
import script from "./TransformationFactoryPopup.vue?vue&type=script&lang=js"
export * from "./TransformationFactoryPopup.vue?vue&type=script&lang=js"

import "./TransformationFactoryPopup.vue?vue&type=style&index=0&id=4e22289c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e22289c"]])

export default __exports__